import { lazyRetry } from "@/chunk-loader";
import type { EContentColorOverrideNames } from "@general-ui/edit-section-colors/edit-section-colors-enums";
import { Suspense, type PropsWithChildren } from "react";
const CustomColorOverridePickerLazy = lazyRetry(() => import('./custom-color-override-picker'));

type ICustomColorOverridePickerProps = PropsWithChildren<{
	onFinish?: (themeMode: string, colorVariableName: string) => void;
	contentOverrideName?: EContentColorOverrideNames;
	defaultColorOverride?: string;
	className?: string;
}>;

export default function CustomColorOverridePicker(props: ICustomColorOverridePickerProps) { 
	return (
		<Suspense fallback="">
			<CustomColorOverridePickerLazy {...props} />
		</Suspense>
	);
}